import React, { useEffect } from 'react';
import { Form, Input, message, Modal, Button, Upload } from 'antd';
import { UploadOutlined } from '@ant-design/icons';

const BankForm = ({ visible, onCreate, onCancel, record }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (record) {
      form.setFieldsValue({
        name: record.name,
      });
    } else {
      // Reset form when record is null (for adding new state)
      form.resetFields();
    }
  }, [record, form]);

  const uploadProps = {
    beforeUpload: (file) => {
      const isPNG = file.type === 'image/png';
      const isJPG = file.type === 'image/jpeg';
      if (!isPNG && !isJPG) {
        message.error(`${file.name} is not a png/jpeg file`);
      }
      return isPNG || isJPG || Upload.LIST_IGNORE;
    },
    onChange: (info) => {
      console.log(info.fileList);
    },
    maxCount: 1,
  };

  return (
    <Modal
      visible={visible}
      title={record ? "Update Bank" : "Add Bank"}
      okText="Submit"
      cancelText="Cancel"
      onCancel={() => {
        form.resetFields(); // Reset form fields when modal is closed
        onCancel(); // Call the onCancel handler
      }}
      onOk={() => {
        form
          .validateFields()
          .then((values) => {
            onCreate(values);
            form.resetFields();
          })
          .catch((info) => {
            console.log('Validate Failed:', info);
          });
      }}
      width={800}
    >
      <Form form={form} layout="vertical" name="model_form" initialValues={record}>
        <Form.Item
          name="name"
          label="Name"
          rules={[{ required: true, message: 'Please enter the model name!' }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="file"
          label="Image"
          valuePropName="fileList"
          getValueFromEvent={(e) => (Array.isArray(e) ? e : e?.fileList || [])}
          extra="Only one image file (PNG/JPG) is allowed."
        >
          <Upload {...uploadProps} listType="picture" accept=".png,.jpg,.jpeg">
            <Button icon={<UploadOutlined />}>Upload Image</Button>
          </Upload>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default BankForm;




// import React, { useEffect } from 'react';
// import { Form, Input, message, Modal,Button, Select, Upload } from 'antd';
// import { UploadOutlined } from '@ant-design/icons';

// const BankForm = ({ visible, onCreate, onCancel, record }) => {
//   const [form] = Form.useForm();


//   useEffect(() => {
//     if (record) {
//       console.log("record :", record);
      
//       form.setFieldsValue({
//         name: record.name,
//       });
//     }
//     else {
//       // Reset form when record is null (for adding new state)
//       form.resetFields();
//     }
//   }, [record, form]);

//   const handleChange = (value) => {
//     console.log(`selected ${value}`);
//   };

//     // File validation for image upload
//     const normFile = (e) => {
//       if (Array.isArray(e)) {
//         return e;
//       }
//       if (e && e.fileList) {
//         return e.fileList;
//       }
//       return [];
//     };
  
//     const uploadProps = {
//       beforeUpload: (file) => {
//         const isPNG = file.type === 'image/png';
//         const isJPG = file.type === 'image/jpeg';
//         if (!isPNG && !isJPG) {
//           message.error(`${file.name} is not a png/jpeg file`);
//         }
//         return isPNG || isJPG || Upload.LIST_IGNORE;
//       },
//       onChange: (info) => {
//         console.log(info.fileList);
//       },
//       maxCount: 1,
//     };

//   return (
//     <Modal
//       visible={visible}
//       title={record ? "Update Bank" : "Add Bank"}
//       okText="Submit"
//       cancelText="Cancel"
//       // onCancel={onCancel}
//       onCancel={() => {
//         form.resetFields(); // Reset form fields when modal is closed
//         onCancel(); // Call the onCancel handler
//       }}
//       onOk={() => {
//         form
//           .validateFields()
//           .then(values => {
//             onCreate(values);
//             form.resetFields();
//           })
//           .catch(info => {
//             console.log('Validate Failed:', info);
//           });
//       }}
//       width={800}
//     >
//       <Form
//         form={form}
//         layout="vertical"
//         name="model_form"
//         initialValues={record}
//       >
       
//         <Form.Item
//           name="name"
//           label="Name"
//           rules={[{ required: true, message: 'Please enter the model name!' }]}
//         >
//           <Input />
//         </Form.Item>
//         <Form.Item name="file" label="Image" valuePropName="fileList" getValueFromEvent={normFile} extra="Only one image file (PNG/JPG) is allowed.">
//           <Upload {...uploadProps} listType="picture" accept=".png,.jpg,.jpeg">
//             <Button icon={<UploadOutlined />}>Upload Image</Button>
//           </Upload>
//         </Form.Item>
//       </Form>
//     </Modal>
//   );
// };

// export default BankForm;